import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

import './fragments/GroceryFragment';

export const fetchGrocery = async (orderId: string) => {
  const response = await queryExecute({
    query: graphql(`
      query Grocery($orderId: String!) {
        grocery(orderId: $orderId) {
          ...GroceriesFragment
        }
      }
    `),
    variables: {
      orderId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.grocery;
};
